<template>
  <div>
    <b-row v-if="accounts.length || (!showNoThing && !accounts.length)">
      <b-col md="12">
        <h4 class="mb-1">
          <h4>{{ $t("dashboard.accounts-list") }}</h4>
        </h4>
      </b-col>
      <template v-if="accounts.length">
        <b-col
          v-for="(account,index) in accounts"

          :key="'account'+index"
          md="4"
        >
          <instagram-account-card
            :account="account"
            :token-invalid="invalidAccountIds.includes(account.id)"
          />
        </b-col>
      </template>
    </b-row>
    <div
      v-if="showNoAccount"
      class="d-flex justify-content-center flex-column align-items-center mb-3"
    >
      <b-card-title
        title-tag="h4"
        class="font-weight-bold mb-1 text-center mt-2"
      >
        {{ $t('dashboard.no-insta-accounts') }}
      </b-card-title>
      <b-button
        :disabled="loading"
        class="btn-instagram-gradient"
        @click="authInstagram(false)"
      >
        <b-spinner
          v-if="loading"
          small
          class="mr-1"
        />
        <feather-icon
          icon="InstagramIcon"
          class="mr-50"
        />
        <span>{{ $t('instagram.add-new') }}</span>
      </b-button>
      <b-button
        :disabled="loading"
        class="btn-instagram-gradient mt-2"
        @click="authInstagramDirect(false)"
      >
        <b-spinner
          v-if="loading"
          small
          class="mr-1"
        />
        <feather-icon
          icon="InstagramIcon"
          class="mr-50"
        />
        <span>{{ $t('instagram.connect-instagram-account') }}</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import InstagramAccountCard from '@/views/owner-instagram/account/components/InstagramAccountCard'
import {
  BRow, BCol, BButton,
  BSpinner, BCardTitle,
} from 'bootstrap-vue'
import AuthMixin from '@/views/auth/mixins/auth-mixin'

export default {
  name: 'InstagramAccountsBox',
  components: {
    InstagramAccountCard,
    BRow,
    BCol,
    BButton,
    BCardTitle,
    BSpinner,
  },
  mixins: [AuthMixin],
  props: {
    accounts: {
      type: Array,
      default: () => [],
    },
    showNoAccount: {
      type: Boolean,
      default: false,
    },
    showNoThing: {
      type: Boolean,
      default: false,
    },
    invalidAccountIds: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
